import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import InfoCircleIcon from '@8x8/oxygen-icon/icons/InfoCircleIcon'

import { Flex } from '~/components/common/containers'

const Container = styled(Flex)`
  border-radius: 4px;
  font-size: 15px;
  line-height: 24px;
  padding: 10px;
  box-sizing: border-box;

  background-color: #daebfa;
  color: #000;
`

const StyledIcon = styled(InfoCircleIcon)`
  margin-right: 13px;
`

const InfoBox = ({ children }) => (
  <Container fullWidth>
    <StyledIcon
      color='#5e6d7a'
      theme={{ size: '24px' }}
    />
    <div>{children}</div>
  </Container>
)

InfoBox.propTypes = {
  children: PropTypes.node
}

export default InfoBox
